export default function removeNullValues(data) {
  return JSON.parse(
    JSON.stringify(data, (key, value) => {
      return value === null ? undefined : value;
    }),
  );
}
